import { Trophy, Store, LifeBuoy, TrendingUp } from "lucide-react";
import { useNavigate } from "react-router-dom";
import HomepageTile from "./HomepageTile";
import hypedropBg from "@/assets/hypedrop-logo-bg.png";
import { PARTNER } from "@/config/partner";

const HomepageTiles = () => {
  const navigate = useNavigate();

  return (
    <section className="py-3 md:py-5 px-4">
      <div className="container mx-auto max-w-5xl space-y-4 md:space-y-5">
        {/* Partner - Largest tile, full width */}
        {/* TODO: confirm final Rainbet bonus terms before launch */}
        <HomepageTile
          label="Bonus Offer"
          title={PARTNER.displayName}
          subtitle="$30,000 Monthly Leaderboard + Monthly Wager Milestones"
          backgroundImage={PARTNER.logo ?? undefined}
          onClick={() => window.open(PARTNER.affiliateUrl, "_blank")}
          glowColor="primary"
          size="xl"
          animationDelay={0}
          hideTitle={!!PARTNER.logo}
          logoPosition="center"
        />

        {/* HypeDrop - Slightly smaller, full width */}
        <HomepageTile
          label="Bonus Offer"
          title="HYPEDROP"
          subtitle="€10,000 Leaderboard + 5% Deposit Bonus"
          backgroundImage={hypedropBg}
          onClick={() => window.open("https://hypedrop.com/r/GAMDUCKS", "_blank")}
          glowColor="primary"
          size="lg"
          animationDelay={100}
          hideTitle
          logoPosition="center"
        />

        {/* Secondary tiles - 4 column grid with staggered animation */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          <HomepageTile
            label="Compete"
            title="Leaderboards"
            icon={Trophy}
            onClick={() => navigate("/leaderboards")}
            glowColor="primary"
            size="md"
            animationDelay={200}
          />
          <HomepageTile
            label="Rewards"
            title="Monthly Milestones"
            icon={TrendingUp}
            onClick={() => navigate("/milestones")}
            glowColor="primary"
            size="md"
            animationDelay={250}
          />
          <HomepageTile
            label="Rewards"
            title="Store"
            icon={Store}
            onClick={() => navigate("/store")}
            glowColor="primary"
            size="md"
            animationDelay={300}
          />
          <HomepageTile
            label="Help"
            title="Support"
            icon={LifeBuoy}
            onClick={() => navigate("/support")}
            glowColor="primary"
            size="md"
            animationDelay={350}
          />
        </div>
      </div>
    </section>
  );
};

export default HomepageTiles;
